/* Pawori: de header maakt zich geleidelijk los terwijl je scrollt.
   --os-f loopt van 0 naar 1 over de eerste RANGE pixels, met een zachte easing. */
(function () {
  var header = document.querySelector('.header');
  if (!header) return;
  var START = 20, RANGE = 140, last = -1;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ease(x) { return x * x * (3 - 2 * x); } /* smoothstep */
  function update() {
    var raw = Math.min(1, Math.max(0, (window.scrollY - START) / RANGE));
    var f = reduce ? (raw > 0.5 ? 1 : 0) : ease(raw);
    f = Math.round(f * 1000) / 1000;
    if (f !== last) {
      last = f;
      header.style.setProperty('--os-f', f);
      header.classList.toggle('os-floating', f > 0.5);
    }
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('load', update);
  update();
})();
